import React from 'react'

import { useConfirmCardPayment } from './StripeLoader'

export default function GlobalComponents() {
  const { renderPaymentFailedModal } = useConfirmCardPayment()
  return <React.Fragment>{renderPaymentFailedModal()}</React.Fragment>
}
